import { useMarketStatus } from "../hooks/useMarketStatus.js";
import { MoonIcon, PlusIcon, SunIcon } from "./Icons.js";
import { DEFAULT_CHART_SIZE } from "../lib/chartSizes.js";
import type { GridSize, Theme } from "../store/workspace.js";

interface HeaderProps {
  theme: Theme;
  onToggleTheme: () => void;
  onAdd: (size: GridSize) => void;
}

export function Header({
  theme,
  onToggleTheme,
  onAdd,
}: HeaderProps) {
  const { data: status } = useMarketStatus();

  return (
    <header className="app-header">
      <div className="app-header__brand">
        <span className="app-header__logo" aria-hidden>
          ◔
        </span>
        <div className="app-header__title">
          <h1>ChartAndGo</h1>
          <MarketPill isOpen={status?.isOpen} />
        </div>
      </div>

      <div className="app-header__actions">
        <button
          type="button"
          className="button button--primary add-chart-button"
          onClick={() => onAdd(DEFAULT_CHART_SIZE)}
          aria-keyshortcuts="Meta+K Control+K"
          title="Add chart (⌘K)"
        >
          <span className="add-chart-button__icon" aria-hidden>
            <PlusIcon />
          </span>
          <span>Add chart</span>
          <kbd className="button__kbd">⌘K</kbd>
        </button>
        <button
          type="button"
          className="icon-button"
          onClick={onToggleTheme}
          aria-label={
            theme === "dark" ? "Switch to light mode" : "Switch to dark mode"
          }
        >
          {theme === "dark" ? <SunIcon /> : <MoonIcon />}
        </button>
      </div>
    </header>
  );
}

function MarketPill({ isOpen }: { isOpen: boolean | undefined }) {
  if (isOpen === undefined) return null;
  return (
    <span className={`market-pill ${isOpen ? "market-pill--open" : ""}`}>
      <span className="market-pill__dot" />
      {isOpen ? "Market open" : "Market closed"}
    </span>
  );
}
